import { render, staticRenderFns } from "./PraticeIntroSection.vue?vue&type=template&id=57e87116"
import script from "./PraticeIntroSection.vue?vue&type=script&lang=ts"
export * from "./PraticeIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./PraticeIntroSection.vue?vue&type=style&index=0&id=57e87116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports